import { SET_VALIDATIONS, SET_MY_VALIDATIONS } from '../types'

const reducer = (state, action) => {
  switch(action.type) {
    case SET_VALIDATIONS:
      return {
        ...state,
        validations: action.payload,
        validationsFetched: true
      }
    case SET_MY_VALIDATIONS:
      return {
        ...state,
        myValidations: action.payload,
        validationsFetched: true
      }
    default:
      return state
  }
}

export default reducer
